import React from 'react';
import classnames from 'classnames';
import { string, func } from 'prop-types';

import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './ArticleCard.css';

const ArticleCard = ({ imgUrl, title, articleDate, dateHighlight, description, link, onClick, imgClass }) => (
  <div className={styles.card}>
    <div className={classnames(styles.imgPlaceholder, imgClass)} style={{ backgroundImage: `url('${imgUrl}')` }} />
    <div className={styles.cardHeader}>
      <p className={styles.title}>{title}</p>
      <div className={styles.linkWrapper}>
        <p className={styles.date}>
          {articleDate}
          {dateHighlight && <span className={styles.highlight}> {dateHighlight}</span>}
        </p>
        <LinkFreeStanding
          className={styles.link}
          icon={{ direction: 'right', name: 'arrow-right', type: '20' }}
          onClick={onClick}
          size="m"
          withBouncing
        >
          {link}
        </LinkFreeStanding>
      </div>
    </div>
    <p className={styles.description}>{description}</p>
    <LinkFreeStanding
      className={styles.linkDark}
      onClick={onClick}
      size="m"
      medium
    >
      {link}
    </LinkFreeStanding>
  </div>
);

ArticleCard.propTypes = {
  imgUrl: string,
  title: string,
  articleDate: string,
  dateHighlight: string,
  description: string,
  link: string,
  onClick: func,
  imgClass: string
};

ArticleCard.displayName = 'ArticleCard';

export default ArticleCard;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/OthersBanner/ArticlesBanner/ArticleCard/ArticleCard.js